import React from 'react';
import PropTypes from 'prop-types';

import { Container } from '../../components/Grid';
import Icon from '../Icon';
import {
  Root,
  Wrapper,
  InformationWrapper,
  Title,
  Tips,
  Tip,
  Links,
  Link,
  Body
} from './style';

const Informations = ({ event }) => {
  return (
    event.detail.description.trim() != '' && (
      <Root background={'/static/images/info_schedule.jpg'}>
        <Container>
          <Wrapper>
            <InformationWrapper>
              <Title>
                <Icon name="schedule" />
                Horaires
              </Title>
              {event.detail.tags && (
                <Tips>
                  {event.detail.tags
                    .split(',')
                    .map((tag, index) => <Tip key={index}>{tag}</Tip>)}
                </Tips>
              )}
              <Body>{event.detail.description}</Body>
              {event.detail.links && (
                <Links>
                  {event.detail.links.map((link, index) => (
                    <Link key={index} target="_blank" href={link.url}>
                      {link.text}
                    </Link>
                  ))}
                </Links>
              )}
            </InformationWrapper>
          </Wrapper>
        </Container>
      </Root>
    )
  );
};

Informations.propTypes = {
  event: PropTypes.object
};

export default Informations;
